export default "{\n    \"viewAllLinkText\": \"Voir tout\"\n}\n"